<template>
  <section class="wxAdd">
    <el-dialog title="绑定手机号" :visible.sync="dialogVisible" width="30%" :before-close="ai_dialog_close">
      <div class="wxAdd-content">
        <el-form
          ref="info"
          :model="inform"
          :rules="rules"
          status-icon
          label-position="left"
          label-width="80px"
        >
          <el-form-item prop="phone" label="手机号：">
            <el-input
              v-model="inform.phone"
              type="text"
              auto-complete="off"
              placeholder="请输入手机号"
              clearable
            />
          </el-form-item>
          <el-form-item class="sms" label="验证码：">
            <el-input
              v-model="info1.captcha"
              class="photoYz"
              type="smsCheck"
              auto-complete="off"
              placeholder="请输入验证码"
              clearable
            />
            <el-button type="text" class="photoSms sms1">
              <img :src="imgUrl" alt="" @click="handleCheckImg">
            </el-button>
          </el-form-item>
          <el-form-item prop="code" label="验证码：" class="sms">
            <el-input
              v-model="inform.code"
              class="numYz"
              auto-complete="off"
              placeholder="请输入验证码"
              clearable
              type="smsCheck"
            />
            <el-button
              :disabled="inform.phone.length != 11 || isSendCode"
              class="photoSms"
              @click="getVerificationCode"
            >
              {{ codeText }}
            </el-button>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="cancelSubmit1">取 消</el-button>
        <el-button type="primary" @click="handleSubmit1">确 定</el-button>
      </span>
    </el-dialog>
  </section>
</template>

<script>
import mock from '@/utils/mock'
import api from '@/api/app'
export default {
  name: 'ComWxPhone',
  components: {},
  props: {
    value: Boolean,
    id: Number,
    rules: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data() {
    return {
      imgUrl: null,
      isSendCode: false,
      codeText: '发送验证码',
      dialogVisible: false,
      loading: false,
      mineInfo: mock.mine.set.viewInfo,
      mineInit: mock.mine.set.init,
      inform: {
        phone: '',
        code: ''
      },
      info1: {
        phone: null,
        captcha: null,
        key: null
      }
    }
  },
  watch: {
    value: {
      handler(val) {
        this.dialogVisible = val
      }
    }
  },
  mounted() {
    this.loading = true
    this.handleCheckImg()
  },
  methods: {
    async handleCheckImg() {
      const obj = await this.mineInit.handleCheckImg()
      this.imgUrl = obj.img
      this.info1.key = obj.key
    },
    getVerificationCode() {
      this.info1.phone = this.inform.phone
      if (this.info1.captcha) {
        api.system.sendSms(this.info1).then(() => {
          this.$message({
            message: '验证码已发送',
            type: 'success'
          })
          this.countDown(60)
        })
      } else {
        this.$message({
          message: '请正确填写图片验证码',
          type: 'error'
        })
      }
    },
    countDown(time) {
      if (time === 0) {
        this.isSendCode = false
        this.codeText = '发送验证码'
        return
      } else {
        this.isSendCode = true
        this.codeText = '重新发送(' + time + ')'
        time--
      }
      setTimeout(() => {
        this.countDown(time)
      }, 1000)
    },
    handleSubmit1() {
      api.mine.update.wx(this.inform).then((res) => {
        this.$message.success('绑定成功')
      })
      this.cancelSubmit1()
    },
    cancelSubmit1() {
      this.dialogVisible = false
      this.$emit('input', false)
    },
    ai_dialog_close() {
      this.cancelSubmit1()
    }
  }
}
</script>

<style lang="scss" scoped >
.wxAdd {
  &-content {
    height: 100%;
    text-align: center;
  }
}
.photoYz{
  width: 73%;
}
.numYz{
  width: 75%;
}
</style>

